export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    title: that.$l('INDEX.table_label_opt') || '操作',
    field: 'col-opt',
    align: 'center',
    fixed: 'right',
    width: 110,
    slots: { default: 'opt' },
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_deviceId') || '设备编号',
    field: 'deviceId',
    align: 'center',
    minWidth: 220,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_versionNo') || '版本编号',
    field: 'versionNo',
    align: 'center',
    width: 100,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_versionName') || '版本名称',
    field: 'versionName',
    align: 'center',
    minWidth: 80,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_userName') || '用户',
    field: 'userName',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_deviceInfo') || '设备信息',
    field: 'deviceInfo',
    align: 'center',
    headerAlign: 'center',
    minWidth: 350,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_statusTime') || '最后一次状态时间',
    field: 'statusTime',
    align: 'center',
    width: 140,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_deviceStatus') || '设备状态',
    field: 'deviceStatus',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    slots: { default: 'deviceStatus' },
  },
  {
    title: that.$l('table_label_ip') || 'ip地址',
    field: 'ip',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true
  },
]
